<template>
	<div
		class="d-md-flex flex-md-row d-sm-flex flex-sm-column nowrap justify-content-center py-3"
	>
	<div
		@click.stop="() => handleClick(1)"
		v-if="ssrReviewData.averageRating[1] > 0"
		class="cursor-pointer align-items-center d-flex flex-row d-md-flex flex-md-column nowrap py-1"
	>
			<div class="d-flex flex-row nowrap">
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-full"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-empty"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-empty"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-empty"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-empty"></use>
				</svg>
			</div>
			<div>
				<span class="mx-2 link-default"
					>{{ content.liheReviews_seeReviews }}
					{{ ssrReviewData.averageRating[1] }}
					{{ content.liheReviews_reviews }}</span
				>
			</div>
		</div>
	<div
		@click.stop="() => handleClick(2)"
		v-if="ssrReviewData.averageRating[2] > 0"
		class="cursor-pointer align-items-center d-flex flex-row d-md-flex flex-md-column nowrap py-1"
	>
			<div class="d-flex flex-row nowrap">
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-full"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-full"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-empty"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-empty"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-empty"></use>
				</svg>
			</div>
			<div>
				<span class="mx-2 link-default"
					>{{ content.liheReviews_seeReviews }}
					{{ ssrReviewData.averageRating[2] }}
					{{ content.liheReviews_reviews }}</span
				>
			</div>
		</div>
	<div
		@click.stop="() => handleClick(3)"
		v-if="ssrReviewData.averageRating[3] > 0"
		class="cursor-pointer align-items-center d-flex flex-row d-md-flex flex-md-column nowrap py-1"
	>
			<div class="d-flex flex-row nowrap">
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-full"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-full"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-full"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-empty"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-empty"></use>
				</svg>
			</div>
			<div>
				<span class="mx-2 link-default"
					><u
						>{{ content.liheReviews_seeReviews }}
						{{ ssrReviewData.averageRating[3] }}
						{{ content.liheReviews_reviews }}</u
					></span
				>
			</div>
		</div>
	<div
		@click.stop="() => handleClick(4)"
		v-if="ssrReviewData.averageRating[4] > 0"
		class="cursor-pointer align-items-center d-flex flex-row d-md-flex flex-md-column nowrap py-1"
	>
			<div class="d-flex flex-row nowrap">
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-full"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-full"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-full"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-full"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-empty"></use>
				</svg>
			</div>
			<div>
				<span class="mx-2 link-default"
					><u
						>{{ content.liheReviews_seeReviews }}
						{{ ssrReviewData.averageRating[4] }}
						{{ content.liheReviews_reviews }}</u
					></span
				>
			</div>
		</div>
	<div
		@click.stop="() => handleClick(5)"
		v-if="ssrReviewData.averageRating[5] > 0"
		class="cursor-pointer align-items-center d-flex flex-row d-md-flex flex-md-column nowrap py-1"
	>
			<div class="d-flex flex-row nowrap">
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-full"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-full"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-full"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-full"></use>
				</svg>
				<svg class="icon text-primary-blue" width="16" height="16">
					<use xlink:href="#___icon___star-full"></use>
				</svg>
			</div>
			<div>
				<span class="mx-2 link-default"
					>{{ content.liheReviews_seeReviews }}
					{{ ssrReviewData.averageRating[5] }}
					{{ content.liheReviews_reviews }}</span
				>
			</div>
		</div>
	</div>
</template>

<script>
// README

import { mapState } from "vuex";

export default {
	name: "Reviews",
	props: {},
	components: {},
	computed: {
		...mapState(["content", "ssrReviewData"]),
	},
	data() {
		return {
			state: {
				selectedRating: null,
			},
		};
	},
	methods: {
		handleClick(rating) {
			// If clicking the same rating, toggle it off (reset filter)
			if (rating === this.state.selectedRating) {
				this.state.selectedRating = null;
				this.$store.commit("resetReviewsArray");
				this.$emit("setRatingsToShow", null);
			} else {
				// Switching to a different rating - always update state and reload
				this.state.selectedRating = rating;
				this.$store.commit("resetReviewsArray");
				this.$emit("setRatingsToShow", rating);
			}
		},
	},
};
</script>

<style scoped></style>
